import React, { Fragment } from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';
import { IAppState } from 'types/app';

type Props = ReturnType<typeof mapStateToProps>;

export function SmallCardCount({ cardsCount, deckSize }: Props) {
  if (cardsCount > deckSize) {
    return <Fragment>No draw limit.</Fragment>;
  }
  if (cardsCount === 0) {
    return <Fragment>No cards waiting.</Fragment>;
  }
  if (cardsCount === 1) {
    return <Fragment>There is 1 card in your Opportunity Deck.</Fragment>;
  }
  return <Fragment>{`There are ${cardsCount} cards in your Opportunity Deck.`}</Fragment>;
}

SmallCardCount.displayName = 'SmallCardCount';

const mapStateToProps = ({ cards: { cardsCount, deckSize } }: IAppState) => ({ cardsCount, deckSize });

export default connect(mapStateToProps)(SmallCardCount);